import { render, staticRenderFns } from "./PerformanceHistory.vue?vue&type=template&id=c2bebd2c&"
import script from "./PerformanceHistory.vue?vue&type=script&lang=js&"
export * from "./PerformanceHistory.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceHistory.vue?vue&type=style&index=0&id=c2bebd2c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports